module.exports = __webpack_public_path__ + "static/media/image2.3f9b7689.png";